import { z } from "zod";

export const ttConfigDataSchema = z.object({
    fansNum: z.number(),
    fansNumYesterday: z.number().nullable(),
    readNum: z.number(),
    incomeNum: z.number(),
    incomeNumYesterday: z.number().nullable(),
    showNumYesterday: z.number().nullable(),
    readNumYesterday: z.number().nullable(),
    likeNumYesterday: z.number().nullable(),
    commentNumYesterday: z.number().nullable(),
});

export type ttConfigData = z.infer<typeof ttConfigDataSchema>;

export const xhsConfigDataSchema = z.object({
    fansNum: z.number(),
    favedNum: z.number(),
    watchNumLastWeek: z.number(),
    likeNumLastWeek: z.number(),
    collectNumLastWeek: z.number(),
    commentNumLastWeek: z.number(),
    fansNumLastWeek: z.number(),
    fansNumYesterday: z.number(),
});

export type xhsConfigData = z.infer<typeof xhsConfigDataSchema>;

export const wxConfigDataSchema = z.object({
    fansNum: z.number(),
    fansNumYesterday: z.number(),
    readNumYesterday: z.number(),
    shareNumYesterday: z.number(),
});

export type wxConfigData = z.infer<typeof wxConfigDataSchema>;

export const bjhConfigDataSchema = z.object({
    fansNum: z.number(),
    fansNumYesterday: z.number().nullable(),
    readNum: z.number(),
    incomeNum: z.number(),
    incomeNumYesterday: z.number().nullable(),
    recommendNumYesterday: z.number().nullable(),
    readNumYesterday: z.number().nullable(),
    likeNumYesterday: z.number().nullable(),
    commentNumYesterday: z.number().nullable(),
});

export type bjhConfigData = z.infer<typeof bjhConfigDataSchema>;

export interface SearchAccountInfoResponse {
    code: number;
    message: string;
    data: ttConfigData | xhsConfigData | wxConfigData | bjhConfigData | null;
}
